import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import "./Footer.css";
import { useTranslation } from 'react-i18next';

function Footer() {
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const email = t('footer.email');

  const copyToClipboard = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
  };

  useEffect(() => {
    if (copied) {
      const timeout = setTimeout(() => setCopied(false), 1000);
      return () => clearTimeout(timeout);
    }
  }, [copied]);

    const handleCompetencesClick = (e) => {
    e.preventDefault();
    
    if (window.location.pathname !== "/") {
      navigate("/", { replace: false });
      setTimeout(() => {
        const section = document.getElementById("competences");
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100); // Petit délai pour s'assurer que la page a rechargé
    } else {
      const section = document.getElementById("competences");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <footer>
      <img src="/assets/black-line-return.png" alt="background" className="black-line" />
      <div className="footer">
        <div className="footer-links">
          <Link to="/" onClick={() => window.scrollTo(0, 0)}>{t('footer.home')}</Link>
          <Link to="/experiences" onClick={() => window.scrollTo(0, 0)}>{t('footer.experiences')}</Link>
          <Link to="/" onClick={handleCompetencesClick}>
            {t('footer.skills')}
          </Link>
          <Link to="/projets" onClick={() => window.scrollTo(0, 0)}>{t('footer.projects')}</Link>
        </div>

        <div className="footer-icons">
          <p>{email}</p>
          <button onClick={copyToClipboard} className="copy-button">
            <div className="icon-wrapper">
              <Clippy className={`icon ${copied ? "hidden" : "visible"}`} />
              <Check className={`icon ${copied ? "visible" : "hidden"}`} />
            </div>
          </button>

          <p class="footer-pipe">|</p>
          
          <a href="https://www.linkedin.com/in/brieucjoonnekindt" target="_blank" rel="noopener noreferrer">
            <img src="/assets/icon/linkedin.png" alt="linkedin" />
          </a>
        </div>
      </div>
      <div className="footer-credits">
        <p>© {t('header.brandName')} - {t('footer.rights')}</p>
        <p className="footer-credit-pipe">|</p>
        <Link to="/mentions-legales" onClick={() => window.scrollTo(0, 0)}>{t('footer.legal')}</Link>
      </div>
    </footer>
  );
}

function Clippy(props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={props.className}
    >
      <path d="M5.75 4.75H10.25V1.75H5.75V4.75Z" />
      <path d="M3.25 2.88379C2.9511 3.05669 2.75 3.37987 2.75 3.75001V13.25C2.75 13.8023 3.19772 14.25 3.75 14.25H12.25C12.8023 14.25 13.25 13.8023 13.25 13.25V3.75001C13.25 3.37987 13.0489 3.05669 12.75 2.88379" />
    </svg>
  );
}

function Check(props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={props.className}
    >
      <path d="M13.25 4.75L6 12L2.75 8.75" />
    </svg>
  );
}

export default Footer;